import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { MouseEvent, useRef } from "react";
import { components, GroupBase, MenuProps } from "react-select";

import { useIsModal } from "@/components/General/Modal/context/modal.context";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { AutocompleteAddress } from "@/services/bpost.service";

type MenuComponentProps = MenuProps<
    AutocompleteAddress,
    false,
    GroupBase<AutocompleteAddress>
>;

type ExtraProps = {
    onManualEntry: () => void;
};

type BPostAddressFieldMenuComponentProps = MenuComponentProps & ExtraProps;

export const BPostAddressFieldMenuComponent = ({
    onManualEntry,
    ...props
}: BPostAddressFieldMenuComponentProps) => {
    const { t } = useGranite();

    const pointerDownRef = useRef<HTMLElement | null>(null);

    const handleOnPointerDown = (event: MouseEvent) => {
        if (!(event.target instanceof HTMLElement)) return;

        event.preventDefault();

        pointerDownRef.current = event.target;
    };

    const handleOnPointerUp = (event: MouseEvent) => {
        if (!(event.target instanceof HTMLElement)) return;

        event.preventDefault();

        if (pointerDownRef.current === event.target) {
            onManualEntry();
        }

        pointerDownRef.current = null;
    };

    return (
        <components.Menu {...props}>
            {props.children}
            <Button
                color={"link"}
                fullWidth={true}
                className={cn(
                    "tw:cursor-pointer tw:block tw:bg-grey tw:underline tw:p-2 tw:rounded-none"
                )}
                onPointerDown={handleOnPointerDown}
                onPointerUp={handleOnPointerUp}
            >
                {t("bPostAddressField.label.addressNotFound")}
            </Button>
        </components.Menu>
    );
};

export const createBPostAddressFieldMenuComponent =
    (extraProps: ExtraProps) => (props: MenuComponentProps) => {
        const isModal = useIsModal();

        return (
            <BPostAddressFieldMenuComponent
                {...props}
                {...extraProps}
                className={cn(props.className, {
                    "tw:relative! tw:overflow-hidden!": isModal
                })}
            />
        );
    };
